/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCar4wd = createReactComponent("outline", "car-4wd", "IconCar4wd", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M5 15m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M15 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M15 15m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M9 18h6", "key": "svg-4" }], ["path", { "d": "M9 6h6", "key": "svg-5" }], ["path", { "d": "M12 6.5v-.5v12", "key": "svg-6" }]]);

export { IconCar4wd as default };
//# sourceMappingURL=IconCar4wd.mjs.map
